import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { SvgIconsModule } from "src/app/module/svg.module";

// vng (@vengreso/angular-components) — ADDED for C3-7 (extension settings):
// vng-card/vng-button/vng-icon/vng-input (R1-R4), vng-toggle (R13), vng-select
// (flygrammar language + csv separator), vng-radio-group/vng-radio-button
// (typing style). Still only-add — no Mat*Module removed (C3-14 does that).
import {
  VngBadgeComponent,
  VngButtonComponent,
  VngCardComponent,
  VngIconComponent,
  VngInputComponent,
  VngRadioButtonComponent,
  VngRadioGroupComponent,
  VngRangeSliderComponent,
  VngSelectComponent,
  VngToggleComponent,
  VngTooltipDirective,
} from "@vengreso/angular-components";

import { DialogCloseButtonComponent } from "src/app/components/dialogs/dialog-close-button/dialog-close-button.component";

import { ExtensionSettingsComponent } from "./extension-settings.component";
import { ExtensionSettingsService } from "./extension-settings.service";
import { ExtensionDetailsComponent } from "./extension-details/extension-details.component";
import { FlygrammarSettingsComponent } from "./flygrammar-settings/flygrammar-settings.component";
import { FlyrewriteSettingsComponent } from "./flyrewrite-settings/flyrewrite-settings.component";
import { SentenceRewriteSettingsComponent } from "./sentence-rewrite-settings/sentence-rewrite-settings.component";
import { TypingStyleSettingsComponent } from "./typing-style-settings/typing-style-settings.component";
import { FlycutTimeoutSettingsComponent } from "./flycut-timeout-settings/flycut-timeout-settings.component";
import { DisabledSitesSettingsComponent } from "./disabled-sites-settings/disabled-sites-settings.component";
import { CsvSeparatorSettingsComponent } from "./csv-separator-settings/csv-separator-settings.component";
import { UnsavedChangesDialogComponent } from "./unsaved-changes-dialog/unsaved-changes-dialog.component";

@NgModule({
  declarations: [
    ExtensionSettingsComponent,
    ExtensionDetailsComponent,
    FlygrammarSettingsComponent,
    FlyrewriteSettingsComponent,
    SentenceRewriteSettingsComponent,
    TypingStyleSettingsComponent,
    FlycutTimeoutSettingsComponent,
    DisabledSitesSettingsComponent,
    CsvSeparatorSettingsComponent,
    UnsavedChangesDialogComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    // C3-14: NgbModule narrowed to NgbPopoverModule — flygrammar-settings and
    // flyrewrite-settings use ngbPopover; ngbTooltip has zero template usages
    // repo-wide (verified).
    NgbPopoverModule,
    NgxSkeletonLoaderModule,
    SvgIconsModule,
    VngCardComponent,
    VngButtonComponent,
    VngIconComponent,
    VngInputComponent,
    VngSelectComponent,
    VngToggleComponent,
    VngRadioGroupComponent,
    VngRadioButtonComponent,
    // v19.7/19.8: vng-range-slider replaced the app's appCustomRangeSlider
    // directive (flycut-timeout + typing-style). The vng-chip-list/vng-chip
    // blocked-domain rows (flygrammar + flyrewrite) were retired for the
    // unified Disabled Sites manager, which uses vng-badge + vngTooltip.
    VngRangeSliderComponent,
    VngBadgeComponent,
    VngTooltipDirective,
    // Shared corner "X" used by unsaved-changes-dialog (and 9 sibling settings dialogs).
    DialogCloseButtonComponent,
  ],
  exports: [ExtensionSettingsComponent],

})
export class ExtensionSettingsModule {}
